module.exports = __webpack_public_path__ + "img/step_import_fail.58c7268d.svg";